<template>
  <div class="SaleOrderCardContainer shadow mb18 brd8">
    <nut-row class="bothCenter">
      <nut-col :span="4" class="leftCenter">
        <img :src="data.goodImage"
             class="sqr40 brd8"/>
      </nut-col>
      <nut-col :span="18" class="colFlex">
        <span class="boldFont">{{ data.goodName }}</span>
        <nut-row class="leftCenter">
          <span class="lightText delText mr12">¥{{(data.originalPrice/100).toFixed(2)}}</span>
          <span class="numberText mr6">¥{{(data.amt/100).toFixed(2)}}</span>
          <img src="https://cdn.waityou.online/0fc3746d-6a91-8694-cc2d-f28792c31520.svg" v-if="data.payMethod == 'WECHAT_JSAPI'" class="sqr16">
          <img src="https://cdn.waityou.online/34c842cc-48ce-6194-8319-122794fd35f3.svg" v-if="data.payMethod == 'ALIPAY_NATIVE'" class="sqr16">
          <img src="https://cdn.waityou.online/1945c1ba-228f-99c3-3c2d-4f051b4f5990.svg" v-if="data.payMethod == 'BALANCE_PAY'" class="sqr16">
        </nut-row>
      </nut-col>
      <nut-col :span="4" class="rightCenter">
        <span class="numberText ft12">已支付</span>
      </nut-col>
    </nut-row>
    <nut-row class="ft12 lightText mt8 ">
      <nut-row class="bothCenter">
        <nut-col :span="18" class="colFlex">
          <span>下单时间：{{data.paidTime}}</span>
          <span class="mt4" v-if="data?.sku?.expressGood">物流单号：{{ data.expressNo?data.expressNo:'-' }}</span>
        </nut-col>
        <nut-col :span="6" class="rightCenter">
          <button class="receiveBtn" @click="$router.push('/sale/fill/info/'+data.orderId)">收货地址</button>
        </nut-col>
      </nut-row>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "SaleOrderCard",
  props: {
    data: {
      type: Object,
      default: ()=>{
        return {

        }
      }
    },
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleOrderCardContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;

  .receiveBtn {
    padding: 4px 10px;
    border: 1px solid #E76A2C;
    border-radius: 14px;
    background: white;
    color: #E76A2C;
  }

  .delText{
    text-decoration: line-through;
  }
}
</style>